<template>
    <div>
        <Nav></Nav>
        <b-overlay :show="pageloading" rounded="sm">
            <PageHeader :linkto="'/profile'" :linkttitle="'返回'" :title="productName"></PageHeader>

            <b-container class="bg-white p-3 p-md-5 shadow-sm rounded ">

                <b-form-select v-model="selected" :options="options" @change="Loadtype"></b-form-select>
                <hr>
                <b-card v-for="(item , index) in purchaselog" v-bind:key="index" :title="item.title " class="mb-2">
                    <h5>{{item.productDetail.product_name }}</h5>
                    <p>

                        訂單編號 {{item.trandno }}<br>
                        付款日期 {{item.payment_date }}<br>
                        有效期限 {{item.start_date }} 起 {{item.end_date }} 止 <br>
                        獲得點數 {{ changePointToString(item.point) }}
                    </p>
                    <p v-if="item.note">
                        <!--{{ item.note }}-->
                    </p>

                    <h5 class="float-right">{{item.currency }} {{item.amount }}</h5>

                </b-card>
                <b-card v-if="purchaselog.length==0" class="mb-2">
                    <b-card-text>
                        <b-img center :src="require('../../assets/ui/emptybox.png')"
                               v-bind="{  width: 75, height: 75}"></b-img>
                        <p class="text-muted text-center">沒有任何紀錄資料</p>
                    </b-card-text>
                </b-card>
                <b-button variant="primary" block @click="loadmore" v-if="!ListinEnd && !loadmoreswitch">讀取更多</b-button>
                <b-alert show variant="primary" class="d-flex justify-content-center pb-5 pt-5" v-if="loadmoreswitch">
                    <b-spinner label="Loading..."></b-spinner>
                    <strong class="ml-3 mt-2">讀取中</strong>
                </b-alert>
                <b-alert show variant="primary" class="d-flex justify-content-center pb-5 pt-5" v-if="ListinEnd && !loadmoreswitch">已無資料</b-alert>

            </b-container>
        </b-overlay>
    </div>


</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'

import { paymentWebtype } from '@/config/env'
import { mapState } from 'vuex'

export default {
  name: 'login',
  components: {Nav, PageHeader},
  data () {
    return {
      productName: '購買紀錄',
      selected: 0,
      options: paymentWebtype,
      pageloading: true,
      offset: 0,
      limite: 20,
      loadmoreswitch: false,
      isLoadMore: false,
      ListinEnd:false
    }
  },
  computed: {
    ...mapState(['purchaselog']),

  },
  created () {
    this.Loadtype()
  },
  mounted () {

    // document.addEventListener("scroll",this.handleScroll)
    // this.$store.dispatch('actionGetPaymentLog', {
    //   limit: this.limite,
    //   offset: this.offset,
    //   type:this.typeselected
    // }).then((res)=>{
    //   this.pageloading=false
    //
    // });

  },
  methods: {
    handleScroll () {
      if (this.$route.path == '/PaymentLog') {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
        let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
        let total = scrollTop + windowHeight
        if (total == scrollHeight && this.isLoadMore) {
          this.loadmore()
          this.isLoadMore = false
        }
        if (total < scrollHeight) {
          this.isLoadMore = true
        }
      }

    },
    Loadtype () {

      this.offset = 0
      this.pageloading = true

      this.$store.dispatch('actionGetPaymentLog', {
        limit: this.limite,
        offset: this.offset,
        type: this.selected
      }).then((res) => {
        this.pageloading = false

      })
    },
    loadmore () {
      if (!this.loadmoreswitch) {
        // this.offset = this.offset + (this.limite + 1)
        this.offset = this.offset + 1

        this.loadmoreswitch = true
        this.$store.dispatch('actionGetPaymentLog', {
          limit: this.limite,
          offset: this.offset,
          type: this.selected
        }).then((res) => {
          if (res.data.length == 0) {
            this.ListinEnd = true
            setTimeout(() => {
              this.ListinEnd = false
            }, 3000)

          }
          this.loadmoreswitch = false
        })
      }
    },
    changePointToString (point) {

      return point == 9999999 ? '無限制' : point

    }

  }
}
</script>
